export function isMaxLength(str: string, maxCharacters: number)
{
  return str.length <= maxCharacters;
}
